import { editorPagesAtom, isSavingAtom } from '@/atoms/_editorAtoms'
import { selectedPageAtom, pageLoadingAtom } from '@/atoms/editorAtoms'
import { useRecoilState, useRecoilValue } from 'recoil'
import { useUpdatePageItems } from '@/hooks/editor/useUpdatePageItems'
import { useErrorHandler } from 'hooks/utility/useErrorHandler'

export const useNavigatePage = () => {
  const editorPages = useRecoilValue(editorPagesAtom)
  const [selectedPage, setSelectedPage] = useRecoilState(selectedPageAtom)
  const [pageLoading, setLoadingPage] = useRecoilState(pageLoadingAtom)
  const isSaving = useRecoilValue(isSavingAtom)
  const { saveItems } = useUpdatePageItems()
  const handleError = useErrorHandler('Editor')

  const navigateToPage = (page) => setSelectedPage(page)
  const nextPage = () =>
    selectedPage !== editorPages.length && navigateToPage(selectedPage + 1)
  const previousPage = () =>
    selectedPage !== 1 && navigateToPage(selectedPage - 1)

  return async (page) => {
    if (isSaving) return
    if (!pageLoading) {
      setLoadingPage(true)
      try {
        await saveItems()
        if (typeof page === 'number') {
          navigateToPage(page)
        }
        if (page === 'previous') {
          previousPage()
        }
        if (page === 'next') {
          nextPage()
        }
      } catch (error) {
        // The canvas could not be synced into the page, so leaving it would
        // drop its unsynced edits: the page stays, and the person is told,
        // as a Save that fails the same way tells them.
        handleError(error?.message, error)
      } finally {
        // pageLoading gates every page-nav control; a saveItems throw must
        // not leave navigation permanently dead.
        setLoadingPage(false)
      }
    }
  }
}

export default useNavigatePage
